import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../services/service.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Chart, ChartConfiguration, ChartType } from 'chart.js';



interface Country {
  name: string;
  flag: string;
  area: number;
  population: number;
}

const COUNTRIES: Country[] = [
  {
    name: 'Russia',
    flag: 'f/f3/Flag_of_Russia.svg',
    area: 17075200,
    population: 146989754
  },
  {
    name: 'Canada',
    flag: 'c/cf/Flag_of_Canada.svg',
    area: 9976140,
    population: 36624199
  },
  {
    name: 'United States',
    flag: 'a/a4/Flag_of_the_United_States.svg',
    area: 9629091,
    population: 324459463
  },
  {
    name: 'China',
    flag: 'f/fa/Flag_of_the_People%27s_Republic_of_China.svg',
    area: 9596960,
    population: 1409517397
  }
];

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})

export class UserManagementComponent implements OnInit {
  selectall:boolean=false;
  visible:boolean=false;
  userdata:any;
  count:any=0;
  
  
  value:any[]=[{
    'name':'jeevanth',
     'userid':'1',
      'Enable':'yes',
      'userplan':'400'
  },
  {
    'name':'sarin',
     'userid':'2',
      'Enable':'no',
      'userplan':'500'
  },
  {
    'name':'kamesh',
     'userid':'3',
      'Enable':'yes',
      'userplan':'400'
  },
  {
    'name':'dakshek',
     'userid':'4',
      'Enable':'no',
      'userplan':'600'
  },
  {
    'name':'dak',
     'userid':'5',
      'Enable':'no',
      'userplan':'600'
  },
  {
    
      'name':'hari',
       'userid':'6',
        'Enable':'no',
        'userplan':'600'
    
  }
  ,
  {
    'name':'Dhanush',
       'userid':'7',
        'Enable':'no',
        'userplan':'600'
  },
  {
    'name':'Iniya',
       'userid':'4',
        'Enable':'no',
        'userplan':'600'
  },
  {
    'name':'mohamed',
       'userid':'4',
        'Enable':'no',
        'userplan':'600'
  },
  {
    'name':'sara',
       'userid':'4',
        'Enable':'no',
        'userplan':'600'
  },
  {
    'name':'ganesh',
       'userid':'4',
        'Enable':'no',
        'userplan':'600'
  }


];
  
  constructor(private ServerService: ServiceService,private http: HttpClient,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.postData();
    
  }
  
  
  countries = COUNTRIES;
  postData() {
    // Prepare the request body
    // Prepare the request body as `application/x-www-form-urlencoded`
    // const body = new HttpParams()
    // .set('api_version', '2')
    // .set('client_id', 'pmtgw1')
    // .set('ps_key', '3cd4_57b3_9d73_54BB')
    // .set('nas_id', 'rlcalcare')
    // .set('action_id', 'get_user_record')
    // .set('req_params', JSON.stringify({ req_id: 'string', user_id: '9443438661' }));

  // Set headers
  // const headers = new HttpHeaders({
  //   'Content-Type': 'application/x-www-form-urlencoded',
  // });

  // Make the API call using your service
  // this.ServerService.sendServer2(body.toString(), headers).subscribe(
  //   (response) => {
  //     console.log('API Response:', response);
  //   },
  //   (error) => {
  //     console.error('Error:', error);
  //   }
  // );
}

openLarge(content) {
  this.modalService.open(content, {
    size: 'lg'
  });
 
}

// openSmall(content) {
//   this.modalService.open(content, {
//     size: 'sm'
//   });
// }

openSmall(content: any) {
  this.modalService.open(content, { windowClass: 'custom-modal' });
}

// private getDismissReason(reason: any): string {
//   if (reason === ModalDismissReasons.ESC) {
//     return 'by pressing ESC';
//   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
//     return 'by clicking on a backdrop';
//   } else {
//     return `with: ${reason}`;
//   }
// }

Delete()
{
  Swal.fire({
    title: 'Are you sure to Delete?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Delete it!'
  });
}

display()
{
 this.visible=!this.visible;
}
child()
{
  for(let i=0;i<this.value.length;i++)
  {
    if(this.value[i])
    {
      this.value[i].selected=this.selectall;
    }
  }
}
update(item:any)
{
  if(item.selected)
  {
    alert("You are selected One item");
    this.count++;
    console.log(this.count);
    if(this.count==this.value.length && this.count>=this.value.length )
      {
        this.selectall=true;
      }
      else if(this.count==this.value.length)
      {
        this.count=0;
      }
  }
  else
  {
    this.selectall=false;
    const index = item.selected.indexOf(item);
     item.selected.splice(index, 1);
     alert('deleted Succesfully');
  }

  
}


// !----!--!



 
}
